"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GwStateFlow = void 0;
const state_flow_1 = require("@video/state-flow");
exports.GwStateFlow = new state_flow_1.StateFlow();
//# sourceMappingURL=state-flow.js.map